import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import AuthRoutes from '@/router/Auth'
import UserRoutes from '@/router/user'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  ...AuthRoutes,
  ...UserRoutes
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
